import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    previewContent: PropTypes.object.isRequired,
    modalContent: PropTypes.object.isRequired,
    isActive: PropTypes.bool,
  },
  getInitialState() {
    return {
      isActive: this.props.isActive,
      fadeClassName: "modal-fade-up",
      scrollPos: 0,
      isChangeElements: false,
      isReturnElements: false,
    };
  },
  changeElements() {
    const modalView = document.getElementById("modal-view");
    if (modalView && this.state.isChangeElements === false) {
      var window = document.getElementById("bg-boxed");
      $(window).append(modalView);
      this.setState({
        isChangeElements: true,
      });
    }
  },
  returnElements() {
    if (this.state.isChangeElements) {
      const returnElements = document.getElementById("return-elements");
      const returnPlace = document.getElementById("return-place");
      $(returnPlace).append(returnElements);
      this.setState({
        isChangeElements: false,
        isReturnElements: false,
      });
    }
  },
  openModal() {
    var scrollPos = window.pageYOffset;
    var marginLeft =
      (window.innerWidth - $(".royal_preloader .container").outerWidth()) / 2;
    var width = window.innerWidth > 767 ? "" : "100%";
    $("body").css({
      marginLeft: marginLeft,
      width: width,
    });
    this.setState({
      fadeClassName: "modal-fade-up",
      isActive: true,
      scrollPos: scrollPos,
    });
  },
  closeModal() {
    $("body").css({
      marginLeft: '',
      width: '',
    });
    this.setState({
      fadeClassName: "modal-fade-down",
    });
    setTimeout(function () {
    this.setState({
      isActive: false,
      isReturnElements: true,
    });
    }.bind(this), 300);
  },
  handleRejectButton() {
    if (this.props.rejectFunc != undefined) {
      this.props.rejectFunc();
    }
    this.closeModal();
  },
  handleModalContent() {
    this.openModal();
  },
  componentDidUpdate() {
    this.changeElements();
    this.state.isReturnElements || this.state.isActive === false
      ? this.returnElements()
      : "";
  },
  componentWillUnmount() {
    this.closeModal();
  },
  render() {
    const previewContent = this.props.previewContent;
    return (this.state.isActive && this.props.isActive) ||
      (this.state.isActive && this.props.isActive == undefined) ? (
      <div id={this.state.isChangeElements ? "return-place" : ""}>
        <div onClick={this.handleModalContent} className="cursor-pointer">
          {previewContent}
        </div>
        <div className="modal-view">
          <div className="modal-view-xl-dialog">
            <div className="modal-view-overAll">
              <div
                className="modal-view-overlay"
                onClick={this.handleRejectButton}
              >
              </div>
              <div className={this.state.fadeClassName}>
                <div
                  className="bg-white position-absolute w-100 border-bottom"
                  style={{
                    zIndex: 9998,
                    borderRadius: '16px 16px 0 0',
                  }}
                >
                  {/* <button
                    type="button"
                    className="close close__modal position--modalclose"
                    aria-label="Close"
                    onClick={() => this.closeModal()}
                  >
                    <span className="text-fz-24px float-right m-2" aria-hidden="true">×</span>
                  </button>
                  <h6 className="text-fw-bold text-center mb-3_5">{' '}</h6> */}
                </div>
                <div className="modal-view-content">
                  {this.props.modalContent}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    ) : (
      <div id={this.state.isChangeElements ? "return-place" : ""}>
        <div id={this.state.isChangeElements ? "return-elements" : ""}>
          <div onClick={this.handleModalContent} className="cursor-pointer">
            {previewContent}
          </div>
        </div>
      </div>
    );
  },
});
